import { Box } from "@twilio-paste/core/box";
import { MediaBody, MediaFigure, MediaObject } from "@twilio-paste/core/media-object";
import { Text } from "@twilio-paste/core/text";
import { ProductFlexIcon } from "@twilio-paste/icons/esm/ProductFlexIcon";
import { styled } from "@twilio-paste/styling-library";
import { Link } from "gatsby";
import React from "react";

const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;

    &:visited {
        color: inherit;
    }
`;

interface HeaderLogoProps {
    title?: string;
    subtitle?: string;
}

const HeaderLogo: React.FC<HeaderLogoProps> = ({ title, subtitle }) => (
    <Box
        display="flex"
        alignItems="center"
        paddingRight="space70"
        paddingLeft="space70"
        borderRightColor="colorBorderInverseWeaker"
        borderRightStyle="solid"
        borderRightWidth={["borderWidth0", "borderWidth0", "borderWidth10"]}
        minWidth={["5rem", "5rem", "21.75rem"]}
    >
        <MediaObject verticalAlign="center">
            <MediaFigure spacing="space40">
                <ProductFlexIcon
                    size="sizeIcon80"
                    color="colorTextIconBrandInverse"
                    decorative={false}
                    title="Description of icon"
                />
            </MediaFigure>
            <MediaBody>
                <Text as="div" fontSize="fontSize40" lineHeight="lineHeight40" color="colorTextInverse">
                    <StyledLink to="/">{title}</StyledLink>
                </Text>
                <Text
                    as="div"
                    fontSize="fontSize20"
                    fontWeight="fontWeightNormal"
                    lineHeight="lineHeight20"
                    color="colorTextInverse"
                >
                    {subtitle}
                </Text>
            </MediaBody>
        </MediaObject>
    </Box>
);

export { HeaderLogo };
